<template>
  <v-app class="back" :class="{ dark: isDarkMode }">
    <div>
      <!-- side nav -->

      <v-navigation-drawer
        class="wfm-navbar z-30"
        v-model="drawer"
        :mini-variant="miniVariant"
        fixed
        :color="$vuetify.theme.currentTheme.navigationColor"
        app
        permanent
        :expand-on-hover="false"
        width="300"
        mini-variant-width="100"
      >
        <div class="my-2 font-bold">
          <div class="flex justify-center items-start">
            <div class="image-container relative flex items-start justify-center">
              <template v-if="orgData">
                <div class="">
                  <img
                    class="image-container ml-0 cursor-pointer"
                    v-if="orgData.logo"
                    :src="getLogoImage"
                    @click="goToDashboard"
                  />
                  <img
                    v-else
                    class="image-container ml-0 cursor-pointer"
                    src="@/assets/img/CW_DEFAULT.png"
                    @click="goToDashboard"
                  />
                </div>
              </template>
              <template v-else>
                <v-skeleton-loader height="40" type="card" width="80"></v-skeleton-loader>
              </template>
            </div>
          </div>

          <v-divider></v-divider>

          <v-list class="scrollable-list" dense>
            <template v-for="(item, i) in menuItems">
              <template v-if="item.visible">
                <v-list-item
                  :class="{
                    'selected-menu': isSelected(i)
                  }"
                  :key="i"
                  :to="item.to"
                  router
                  exact
                  class="mb-0 border-b"
                  v-if="item.to"
                  :color="$vuetify.theme.currentTheme.primary"
                  @mouseenter="showPopup(i, $event)"
                  @mouseleave="scheduleHidePopup"
                >
                  <v-list-item-action>
                    <div class="flex flex-col align-center justify-center">
                      <v-icon size="18" :color="isSelected(i) ? 'white' : '#21427d'">{{
                        item.icon
                      }}</v-icon>
                      <p
                        class="mb-0 text-sm font-semibold mini-variant-text"
                        :class="isSelected(i) ? 'text-white' : 'text-[#21427d]'"
                        v-if="miniVariant"
                        :style="{ color: !isSelected(i) ? '#21427d' : '' }"
                      >
                        {{ item.title }}
                      </p>
                    </div>
                  </v-list-item-action>
                  <v-list-item-content v-if="!miniVariant">
                    <p
                      class="mb-0 text-sm font-semibold"
                      :class="isSelected(i) ? 'text-white' : 'text-[#21427d]'"
                      :style="{ color: !isSelected(i) ? '#21427d' : '' }"
                    >
                      {{ item.title }}
                    </p>
                  </v-list-item-content>
                </v-list-item>

                <v-list-group
                  :value="isSelected(i)"
                  :class="{
                    'selected-menu': isSelected(i)
                  }"
                  class="mb-0 border-b"
                  :key="'group-' + i"
                  v-else-if="item.childRoutes"
                  :color="$vuetify.theme.currentTheme.primary"
                  @mouseenter.native="showPopup(i, $event)"
                  @mouseleave.native="scheduleHidePopup"
                  :append-icon="isSelected(i) ? 'mdi-chevron-down white--text' : 'mdi-chevron-down'"
                >
                  <template v-slot:activator>
                    <v-list-item-action>
                      <div class="flex flex-col align-center justify-center">
                        <v-icon size="18" :color="isSelected(i) ? 'white' : '#21427d'">{{
                          item.icon
                        }}</v-icon>
                        <p
                          class="mb-0 text-sm font-semibold mini-variant-text"
                          :class="isSelected(i) ? 'text-white' : 'text-[#21427d]'"
                          v-if="miniVariant"
                        >
                          {{ item.title }}
                        </p>
                      </div>
                    </v-list-item-action>
                    <v-list-item-content v-if="!miniVariant">
                      <p
                        class="mb-0 text-sm font-semibold"
                        :class="isSelected(i) ? 'text-white' : 'text-[#21427d]'"
                      >
                        {{ item.title }}
                      </p>
                    </v-list-item-content>
                  </template>

                  <!-- 2nd logo and title -->
                  <template v-if="!miniVariant">
                    <v-list-item
                      v-for="(child, j) in item.childRoutes"
                      :key="child.id || j"
                      :class="{
                        'bg-gray-100': !$route.path.startsWith(child.to),
                        'hover:bg-blue-100 hover:dark-icon-bg': !$route.path.startsWith(child.to),
                        'selected-menu child-selected': $route.path.startsWith(child.to)
                      }"
                      :to="child.to"
                      router
                      exact
                      :color="$vuetify.theme.currentTheme.primary"
                    >
                      <v-icon
                        size="18"
                        class="ml-6 mr-4"
                        :color="$route.path.startsWith(child.to) ? 'white' : '#21427d'"
                        >{{ child.icon }}</v-icon
                      >
                      <v-list-item-content>
                        <v-list-item-title
                          :class="
                            $route.path.startsWith(child.to) ? 'text-white' : 'text-[#21427d]'
                          "
                          >{{ child.title }}</v-list-item-title
                        >
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-list-group>
              </template>
            </template>
          </v-list>
        </div>
      </v-navigation-drawer>
      <!-- main header -->
      <v-app-bar
        fixed
        dense
        class="flex justify-between"
        :color="$vuetify.theme.currentTheme.appBarColor"
        app
      >
        <div class="d-flex justify-center">
          <v-app-bar-nav-icon
            @click.stop="miniVariant = !miniVariant"
            class="ma-0"
            color="white"
          ></v-app-bar-nav-icon>
          <div class="flex-2 flex justify-center items-center ml-4" v-if="showGlobalSearch">
            <GlobalSearch :enableFetch="allowEnableFetch" class="w-full max-w-xl" />
          </div>
        </div>

        <div class="flex justify-end items-center shrink-0">
          <div class="flex justify-end mr-4">
            <div class="flex justify-end">
              <!-- <div
                class="hidden md:flex flex-col items-end mr-4 justify-center"
                v-if="shouldShowUpgradeButton"
              >
                <v-btn
                  color="#21427d"
                  class="white--text px-4 font-bold normal-case"
                  small
                  outlined
                  @click="showUpgradePlan = true"
                >
                  Upgrade Now
                </v-btn>
              </div> -->
              <img
                src="@/assets/img/Google_Play.png"
                alt="Download App"
                class="white--text cursor-pointer download-image"
                @click="downloadApp"
              />
            </div>
            <v-icon class="white--text" @click="toggleOpenDrawer">mdi-help-circle-outline</v-icon>
          </div>
          <!-- <div class="flex items-center justify-end mr-4"> -->
          <v-btn
            color="white"
            outlined
            small
            class="font-bold normal-case rounded-lg mr-4 px-4"
            @click="showNotificationDialog = true"
          >
            <v-icon left small>mdi-bell-plus-outline</v-icon>
            Send Notification
          </v-btn>
          <!-- </div> -->
          <div class="transition-colors duration-500">
            <div class="flex justify-end mr-4">
              <button @click="toggleDarkMode" class="focus:outline-none text-white">
                <span v-if="isDarkMode" class="mdi mdi-weather-sunny text-2xl"></span>
                <span v-else class="mdi mdi-weather-night text-2xl"></span>
              </button>
            </div>
          </div>
          <div class="notification mr-4">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" v-show="isbellIconEnabled('NOTIFICATIONS')">
                  <v-badge color="red" overlap :content="alertsCount" v-if="alertsCount">
                    <v-icon class="ml-2 white--text" @click="toggleDropdown">mdi-bell</v-icon>
                  </v-badge>
                  <v-icon class="ml-2 white--text" @click="toggleDropdown" v-else>mdi-bell</v-icon>
                </div>
              </template>

              <v-card class="w-[28rem] max-h-[40rem]">
                <v-list class="mt-4 w-full">
                  <v-list-item v-for="(notification, index) in alerts.slice(0, 4)" :key="index">
                    <v-alert
                      :type="notification.type"
                      class="w-full p-1 text-base"
                      :color="categoryColor(notification.notificationGenric)?.bgColor"
                      text
                      outlined
                    >
                      {{ notification.message }}
                    </v-alert>
                  </v-list-item>
                  <v-list-item v-if="!alerts.length">
                    <v-alert type="warning" color="blue" class="w-full p-1 text-base">
                      No alerts
                    </v-alert>
                  </v-list-item>
                  <v-list-item
                    @click="handleSeeAll"
                    class="cursor-pointer flex justify-center hover:bg-slate-200 hover:dark-icon-bg dark-text-color mx-4 rounded"
                  >
                    See all &nbsp;
                    <span v-if="this.alertsCount > 4"> (+{{ this.alertsCount - 4 }} more)</span>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </div>

          <div class="user-menu relative z-30">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" class="custom-btn">
                  <div>
                    <img
                      v-if="user?.user?.profile_image"
                      :src="getEmployeeImage()"
                      alt="Employee Image"
                      class="border border-white-500 rounded-full h-7 w-7 inline -mt-1 mr-2"
                    />
                    <v-icon v-else class="border border-white-500 rounded-full white--text mr-2"
                      >mdi-account</v-icon
                    >
                    <span class="white--text capitalize">Hi, {{ user_name }} </span>
                  </div>
                </v-btn>
              </template>
              <v-list>
                <v-list-item to="/workforce/profile">Profile</v-list-item>
                <!-- <v-list-item to="/workforce/org">Company Settings</v-list-item> -->
                <v-list-item @click="logout()" class="border-b">Logout</v-list-item>
                <v-list-item @click.prevent="openInNewTab"
                  ><span class="colorText">About Product</span></v-list-item
                >
              </v-list>
            </v-menu>
          </div>
        </div>
      </v-app-bar>

      <!-- main content -->
      <v-main class="">
        <div class="flex gap-2 my-1">
          <div class="dialer-overlay" v-if="isDialerOpen">
            <div class="dialer-container">
              <DialerPopOver @handleCloseDialer="openDialerCard" />
            </div>

            <div class="dialer-overlay" v-if="isDialerOpen">
              <div class="dialer-container">
                <DialerPopOver @handleCloseDialer="openDialerCard" />
              </div>
            </div>

            <!-- <div class="help-desk-container">
          <transition name="fade">
            <div v-show="isHelpTextVisible" class="help-text-container">
              <span class="help-text">How can I help you?</span>
            </div>
          </transition>
          <v-btn
            icon
            :color="$vuetify.theme.currentTheme.primary"
            @click="openComplaintCard"
            class="shadow-lg help-desk-btn"
          >
            <v-icon>mdi-comment-processing-outline</v-icon>
          </v-btn>
        </div> -->
            <div class="query-overlay" v-if="isComplaintOpen">
              <div class="query-container">
                <QueryComponent @handleCloseComplaint="openComplaintCard" />
              </div>
            </div>
          </div>
        </div>
        <div class="px-2 h-5/6">
          <router-view />
        </div>
      </v-main>
      <v-dialog v-model="showUpgradePlan" max-width="1200px">
        <v-card class="bg-gray-100 p-4">
          <v-card-title class="headline flex justify-between items-center bg-white px-6 py-4">
            <span class="font-bold text-gray-800">Upgrade Your Plan</span>
            <v-btn icon @click="showUpgradePlan = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pa-6">
            <PlanSelection
              :currentPlanName="currentPlanName"
              :processingPlan="loadingPlan"
              @select-plan="handlePlanSelection"
              @billing-cycle-change="billingCycle = $event"
            />
          </v-card-text>
        </v-card>
      </v-dialog>

      <RazorpayCheckout
        ref="razorpayCheckout"
        :planUserName="userName"
        :planUserEmail="userEmail"
        :planUserContact="userContact"
        :orgInfo="razorpayOrgInfo"
        :paymentType="billingCycle.toUpperCase()"
      />

      <div v-if="isRightDrawerOpen" class="flex justify-between">
        <RightDrawer
          @openCallCutomer="openDialerCard"
          @openHelpDesk="openComplaintCard"
          @downloadEmpApp="downloadApp"
          :isCallingAllowed="isCallingAllowed('CALL_A_CUSTOMER')"
        />
      </div>

      <v-dialog v-model="planStatus" persistent max-width="450">
        <v-card class="text-center pa-6">
          <v-img
            src="https://cdn-icons-png.flaticon.com/512/6179/6179025.png"
            alt="Plan Expired"
            class="mx-auto mb-4 bg-white"
            max-width="120"
          />
          <v-card-title class="headline ml-16">Your plan has expired</v-card-title>
          <v-card-text>
            Your access to this service has been temporarily suspended due to an expired plan.
            Please contact Cuality-Work admin ( pranavbarthwal@myfinfi.com ) to renew your plan and
            regain full access.
            <br />
            Rest assured, all your data and settings are saved and secured.
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              :color="$vuetify.theme.currentTheme.primary"
              class="white--text"
              small
              @click="logout"
              >Log Out</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Popup for menu items -->
      <div
        v-if="showItemPopup && miniVariant"
        class="popup-container"
        :style="{ top: popupPosition.top + 'px', left: popupPosition.left + 'px' }"
        @mouseenter="cancelHidePopup"
        @mouseleave="scheduleHidePopup"
      >
        <div class="popup-header" v-if="currentHoveredItemTitle">
          <v-icon size="18" color="#21427d" class="mr-2">{{ currentHoveredItemTitle.icon }}</v-icon>
          <span class="popup-title">{{ currentHoveredItemTitle.title }}</span>
        </div>
        <div class="popup-content pt-2 scrollable-popup">
          <div
            v-for="(popupItem, index) in popupItems"
            :key="index"
            class="popup-item"
            :class="{ 'popup-item-selected': isPopupItemSelected(popupItem) }"
            @click="navigateTo(popupItem.to)"
          >
            <v-icon
              size="18"
              class="mr-2"
              :color="isPopupItemSelected(popupItem) ? 'white' : '#21427d'"
              >{{ popupItem.icon }}</v-icon
            >
            <span
              class="font-bold text-[#21427d]"
              :class="{
                'font-weight-bold': isPopupItemSelected(popupItem),
                'text-white': isPopupItemSelected(popupItem)
              }"
              >{{ popupItem.title }}</span
            >
          </div>
        </div>
      </div>
      <!-- Chat Agent Widget -->
      <ChatAgentWidget />

      <!-- Manual Notification Dialog -->
      <SendNotificationDialog v-model="showNotificationDialog" />
    </div>
  </v-app>
</template>

<script>
import {
  hasPermission,
  convertToTitleCase,
  isModuleVisible,
  isModuleFeatureAllowed
} from '@/utils/common'
import permissionData from '@/utils/permissions'
import { reformatNotification } from '@/utils/workforce/utils'
import {
  NOTIFICATION_CHANNEL,
  PUSHER_CLIENT_LIB,
  routeConfig
  // USER_GUIDE_LINK,
} from '@/utils/workforce/constants'
import { notificationColor } from '@/utils/workforce/statusColors'
import DialerPopOver from '@/components/DialerPopOver.vue'
import QueryComponent from '@/components/queryComponent.vue'
import GlobalSearch from '@/components/GlobalSearch.vue'
import RightDrawer from '@/components/RightDrawer'
import Pusher from 'pusher-js'
import { axiosUrl } from '@/utils/workforceApi'
import PlanSelection from '@/components/common/PlanSelection.vue'
import RazorpayCheckout from '@/components/common/RazorpayCheckout.vue'
import ChatAgentWidget from '@/components/ChatAgentWidget.vue'
import SendNotificationDialog from '@/components/Workforce/Notifications/SendNotificationDialog.vue'

export default {
  name: 'DefaultLayout',
  data() {
    return {
      orgCode: this.$storage.getUniversal('organization_code'),
      userOrg: this.$storage.getUniversal('user'),
      clipped: true,
      drawer: true,
      fixed: false,
      miniVariant: true,
      right: true,
      user_name: '',
      menuItems: [],
      orgInfo: null,
      currentDate: this.getCurrentDate(),
      searchQuery: '',
      user: {},
      baseUrlS3: process.env.VUE_APP_S3_BASE_URL,
      dropdownVisible: false,
      alerts: [],
      alertsCount: 0,
      useCases: [],
      orgData: null,
      isDialerOpen: false,
      isComplaintOpen: false,
      planStatus: false,
      isDarkMode: false,
      theme: 'light',
      isLoad: false,
      isHelpTextVisible: true,
      allSubCases: [],
      showItemPopup: false,
      popupPosition: { top: 0, left: 0 },
      popupItems: [],
      hidePopupTimeout: null,
      currentHoveredItem: null,
      isRightDrawerOpen: false,
      allowedUseCases: [],
      // Plan Upgrade Data
      showUpgradePlan: false,
      loadingPlan: null,
      billingCycle: 'monthly',
      planName: '', // current plan name
      daysLeft: null,
      lastPaymentAmount: null,
      showNotificationDialog: false
    }
  },
  components: {
    DialerPopOver,
    QueryComponent,
    GlobalSearch,
    RightDrawer,
    PlanSelection,
    RazorpayCheckout,
    ChatAgentWidget,
    SendNotificationDialog
  },

  created() {
    if (typeof window !== 'undefined') {
      this.isDarkMode = localStorage.getItem('theme') === 'dark'
      this.applyTheme()
      this.isLoad = true
    }
  },

  computed: {
    userData() {
      return this.$store.state.wfmPermissions || []
    },
    title() {
      const orgName = this.orgData?.name || ''
      return orgName && `${orgName.charAt(0).toUpperCase()}${orgName.slice(1).toLowerCase()}`
    },
    // New computed properties for Razorpay
    currentPlanName() {
      return this.planName || 'Base' // derived from api later in checkActivePlan
    },
    currentUser() {
      return this.$storage?.getUniversal('user') || {}
    },
    userName() {
      return (
        `${this.currentUser.first_name || ''} ${this.currentUser.last_name || ''}`.trim() || 'User'
      )
    },
    userEmail() {
      return this.currentUser.email || 'user@example.com'
    },
    userContact() {
      return this.currentUser.mobile
    },
    razorpayOrgInfo() {
      const data = this.$storage.getUniversal('orgData')
      return {
        orgId: data?.id,
        planId: data?.plan_id,
        orgName: data?.name
      }
    },
    // existing
    currentHoveredItemTitle() {
      if (this.currentHoveredItem !== null && this.menuItems[this.currentHoveredItem]) {
        return {
          title: this.menuItems[this.currentHoveredItem]?.title,
          icon: this.menuItems[this.currentHoveredItem]?.icon
        }
      }
      return ''
    },
    isClipped() {
      return this.clipped
    },
    selectedItemIndex() {
      return this.menuItems.findIndex((item) => {
        if (item.to && this.$route.path.startsWith(item.to)) {
          return true
        }
        return false
      })
    },
    sparePartEnabled() {
      return (
        hasPermission(this.userData, permissionData.inventoryRead) &&
        isModuleVisible('base_management')
      )
    },
    amcEnabled() {
      return (
        hasPermission(this.userData, permissionData.amcRead) && isModuleVisible('base_management')
      )
    },
    isCollectionEnabled() {
      return isModuleVisible('collection_management')
    },
    checkRouteVisibility() {
      return (
        this.$route.path == '/workforce/leadspage/inventory' &&
        !hasPermission(this.userData, permissionData.leadRead) &&
        this.$route.query?.complaint_no
      )
    },
    getLogoImage() {
      if (this.orgData?.logo) {
        return `${process.env.VUE_APP_S3_BASE_URL + this.orgData?.logo}`
      }
      return null
    },
    isEveryTabsInModule() {
      return (
        isModuleFeatureAllowed('ATTENDANCE', 'MANAGE_ATTENDANCE') ||
        isModuleFeatureAllowed('ATTENDANCE', 'MANAGE_ROSTER')
      )
    },
    allowEnableFetch() {
      if (
        this.$route.path.startsWith('/workforce/collection_management') ||
        this.$route.path.startsWith('/workforce/loan_management') ||
        this.$route.path.startsWith('/workforce/team-review')
      ) {
        return true
      } else {
        return false
      }
    },
    showGlobalSearch() {
      const currentRoute = Object.values(routeConfig).find((route) =>
        this.$route.path.includes(route.path)
      )

      // Check if route exists and is visible
      if (!currentRoute || currentRoute.visibility !== true) {
        return false
      }

      // Use the same logic as SearchConfig.getSelectItems to determine available selection items
      let selectValues = currentRoute.selectValues

      // If activeTabFilter is defined, filter selectValues based on active tab
      if (currentRoute.activeTabFilter) {
        const activeTab = this.$route.query.activeTab || 'Default'
        const filterMap = currentRoute.activeTabFilter
        selectValues = filterMap[activeTab] || filterMap.Default || selectValues
      }

      // Show global search only if there are selection items available
      return selectValues.length > 0
    },
    shouldShowUpgradeButton() {
      return (this.daysLeft !== null && this.daysLeft < 10) || this.lastPaymentAmount === 0
    }
  },
  beforeDestroy() {
    // Clear the interval to avoid memory leaks
    clearInterval(this.helpTextInterval)
    document.removeEventListener('click', this.handleOutsideClick)
  },
  async mounted() {
    await this.initializeLayout()

    document.addEventListener('click', this.handleOutsideClick)
  },
  methods: {
    // New Method for Plan Selection
    async handlePlanSelection(plan) {
      this.loadingPlan = plan.name

      if (!this.$refs.razorpayCheckout) {
        console.error('Razorpay component ref not found')
        this.loadingPlan = null
        return
      }

      const checkoutPlan = {
        name: plan.name,
        // Price should be based on billing cycle
        price: this.billingCycle === 'monthly' ? plan.monthlyPrice : plan.yearlyPrice,
        id: plan.name.toUpperCase(),
        billingCycle: this.billingCycle,
        planRefId: plan._id
      }

      try {
        await this.$refs.razorpayCheckout.processPayment(checkoutPlan)
        // Close dialog on success? Or wait for verify?
        // processPayment handles flow, usually we can close if needed or let it be
      } catch (error) {
        console.error('Payment Flow Error:', error)
      } finally {
        this.loadingPlan = null
      }
    },
    goToDashboard() {
      if (this.$route.path !== '/workforce/dashboard') {
        this.$router.push('/workforce/dashboard').catch((err) => {
          if (err.name !== 'NavigationDuplicated') {
            console.error('Navigation error:', err)
          }
        })
      }
    },
    toggleOpenDrawer() {
      this.isRightDrawerOpen = !this.isRightDrawerOpen
    },
    handleOutsideClick(event) {
      // Close the RightDrawer when clicking outside
      if (this.isRightDrawerOpen) {
        const rightDrawerElement = this.$el.querySelector('.right-drawer-container')
        if (rightDrawerElement && !rightDrawerElement.contains(event.target)) {
          // Check if the click was on the toggle icon
          const toggleIcon = this.$el.querySelector('.mdi-help-circle-outline')
          if (event.target !== toggleIcon && !toggleIcon.contains(event.target)) {
            this.isRightDrawerOpen = false
          }
        }
      }
    },
    getRouteById(id) {
      const menuItem = this.menuItems.find((item) => item.id === id)
      return menuItem ? menuItem.to : null
    },
    toggleDarkMode() {
      this.isDarkMode = !this.isDarkMode
      this.applyTheme()
    },
    applyTheme() {
      const theme = this.isDarkMode ? 'dark' : 'light'
      document.documentElement.classList.toggle('dark', this.isDarkMode)
      this.$vuetify.theme.dark = this.isDarkMode
      localStorage.setItem('theme', theme)
      this.$root.$emit('modeChange')
      this.isLoad = true
    },
    initFb() {
      window.fbAsyncInit = function () {
        if (window.FB) {
          window.FB.init({
            appId: '1622165388539821',
            cookie: true,
            xfbml: true,
            version: 'v19.0'
          })
          window.FB.AppEvents.logPageView()
        }
      }
      ;(function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) {
          return
        }
        js = d.createElement(s)
        js.id = id
        js.src = 'https://connect.facebook.net/en_US/sdk.js'
        js.nonce = 'kyHuC4JA'
        fjs.parentNode.insertBefore(js, fjs)
      })(document, 'script', 'facebook-jssdk')
    },
    isPopselected(i) {
      console.log(i)
    },
    async getDynamicNavLinks() {
      // const config = await this.getConfig()
      const links = []

      // if (config.enabledSubCases?.length && isModuleVisible('COLLECTION_MANAGEMENT')) {
      //   config.enabledSubCases.forEach((subCaseItem, index) => {
      //     const subCasesLink = {
      //       id: `collection-management-${index}`, // Make ID unique
      //       icon: 'mdi-bank',
      //       title: 'Teams',
      //       visible: isModuleVisible('COLLECTION_MANAGEMENT'),
      //       childRoutes: []
      //     }

      //     if (this.userOrg?.branch && !this.userOrg?.role?.includes('WFM_ADMIN')) {
      //       const filteredSubCases = subCaseItem?.subCase?.filter(
      //         (sub) => sub?.branch === this.userOrg?.branch
      //       )
      //       filteredSubCases.forEach((subCase) => {
      //         subCasesLink.childRoutes.push({
      //           id: `subcase-${subCase.name}`,
      //           icon: 'mdi-cash-multiple',
      //           title: convertToTitleCase(subCase.name) || 'tet test',
      //           to: `/workforce/collection-management/${subCase._id}`
      //         })
      //       })
      //     } else {
      //       subCaseItem.subCase.forEach((subCase) => {
      //         subCasesLink.childRoutes.push({
      //           id: `subcase-${subCase.name}`,
      //           icon: 'mdi-cash-multiple',
      //           title: convertToTitleCase(subCase.name) || 'tet test',
      //           to: `/workforce/collection-management/${subCase._id}`
      //         })
      //       })
      //     }

      //     links.push(subCasesLink)
      //   })
      // }

      const modules = [
        // {
        //   key: 'base_management',
        //   icon: 'mdi-bag-checked',
        //   usecase: 'project',
        //   title: 'Project',
        //   permission: permissionData.projectRead
        // },
        {
          key: 'base_management',
          icon: 'mdi-shopping',
          usecase: 'inventory',
          title: 'Products',
          permission: permissionData.inventoryRead
        }
        // {
        //   key: 'base_management',
        //   icon: 'mdi-bag-checked',
        //   usecase: 'default',
        //   title: 'Lead',
        //   permission: permissionData.leadRead
        // }
      ]

      modules.forEach((module) => {
        if (module.key) {
          const moduleVisible =
            hasPermission(this.userData, module.permission) && isModuleVisible(module.key)
          links.push({
            id: `${module.key.toLowerCase()}-${module.title}`,
            icon: module.icon,
            title: module.title,
            to: `/workforce/leadspage/${module.usecase.toLowerCase()}`,
            visible: moduleVisible
          })
        }
      })

      return links
    },
    async fecthAllowedUseCases() {
      try {
        const res = await this.$axios.get(`/orgSetup/allowed-use-cases`)
        this.allowedUseCases = res.data?.data
      } catch (error) {
        console.log(error)
      }
    },
    // async getConfig() {
    //   try {
    //     const response = await this.$axios.get('/org/config')

    //     const data = response.data?.config
    //     this.useCases = data.enabledUseCases
    //     this.$store.dispatch('setSubCases', data.enabledSubCases)
    //     this.$store.dispatch('setUseCase', this.useCases)
    //     const obj = {
    //       directComplete: data.isTaskDirectCompletionAllowedOrg,
    //       recurAllow: data.isTaskRecurrenceAllowedOrg,
    //       isCheckedInSelfie: data.isCheckedInSelfie,
    //       isCheckedOutSelfie: data.isCheckedOutSelfie
    //     }
    //     const jsonString = JSON.stringify(obj)
    //     localStorage.setItem('task', jsonString)
    //     return data || {}
    //   } catch (error) {
    //     console.error('Error fetching config:', error)
    //   }
    // },
    toggleDropdown() {
      this.dropdownVisible = !this.dropdownVisible
    },
    handleSeeAll() {
      this.$router.push('/workforce/notifications?activeTab=notifications')
    },
    async logout() {
      try {
        const res = await this.$axios.post('/auth/v3/logout')
      } catch (error) {
        console.log(error)
        return
      }
      const exportColumnKey = localStorage.getItem('exportColumnSelectedKey')
      const oldUserData = localStorage.getItem('user')
      const oldOrganizationCode = localStorage.getItem('organization_code')
      localStorage.clear()
      if (exportColumnKey) {
        localStorage.setItem('exportColumnSelectedKey', exportColumnKey)
      }
      localStorage.setItem('user', oldUserData)
      localStorage.setItem('organization_code', oldOrganizationCode)
      this.$store.dispatch('resetWfmPermissions')
      this.$store.dispatch('resetSubCase')
      // this.$storage.removeCookie("token"); // Uncomment if token needs to be removed
      this.$router.push('/login')
    },

    async setupMenuItems() {
      let isAnyItemVisible = false

      for (const item of this.menuItems) {
        if (item.visible) {
          isAnyItemVisible = true
        }

        if (!item.visible && this.$route.path === item.to) {
          if (this.$route.path !== '/workforce/dashboard') {
            this.$router.push('/workforce/dashboard').catch((err) => {
              if (err.name !== 'NavigationDuplicated') console.error(err)
            })
          }
        }
      }

      if (!isAnyItemVisible) {
        this.$toast.error("You don't have permission to access the admin portal")
        await this.logout()
        return
      }

      if (this.checkRouteVisibility) {
        const complainRoute = `${this.$route.path}?complaint_no=${this.$route.query?.complaint_no}`
        if (this.$route.fullPath !== complainRoute) {
          this.$router.push(complainRoute).catch((err) => {
            if (err.name !== 'NavigationDuplicated') console.error(err)
          })
        }
        return
      }
    },
    getCurrentDate() {
      const dateObj = new Date()
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }
      return dateObj.toLocaleDateString('en-US', options)
    },
    isSelected(index) {
      const item = this.menuItems[index]

      if (item.to) {
        return this.$route.path.startsWith(item.to)
      }

      // Check if any child route is active for grouped items
      if (item.childRoutes && item.childRoutes.length > 0) {
        return item.childRoutes.some((child) => this.$route.path.startsWith(child.to))
      }

      return false
    },
    isPopupItemSelected(popupItem) {
      return this.$route.path === popupItem.to || this.$route.path.startsWith(popupItem.to + '/')
    },
    getEmployeeImage() {
      return `${this.baseUrlS3 + this.user?.user.profile_image}`
    },
    openInNewTab() {
      window.open('https://www.cualitywork.com/', '_blank')
    },
    loadExternalScripts() {
      const pusherScript = document.createElement('script')
      pusherScript.src = PUSHER_CLIENT_LIB
      pusherScript.async = true
      pusherScript.onload = () => {
        this.initPusher()
      }
      document.head.appendChild(pusherScript)
    },

    initPusher() {
      const userId = this.userOrg?._id

      Pusher.logToConsole = false
      const pusher = new Pusher(process.env.VUE_APP_PUSHER_ID, {
        cluster: process.env.VUE_APP_PUSHER_CLUSTER
      })
      const channel = pusher.subscribe(`${NOTIFICATION_CHANNEL}-${userId}`)
      channel.bind(NOTIFICATION_CHANNEL, (data) => {
        this.alertsCount = data?.pagination.totalCount
        this.alerts = [...reformatNotification(data?.notifications)]
      })
    },

    async fetchNotifications() {
      try {
        const response = await this.$axios.get('/notifications')
        this.alertsCount = response.data?.pagination?.totalCount
        this.alerts = [...reformatNotification(response.data?.notifications)]
      } catch (error) {
        console.error('Error fetching notifications:', error)
      }
    },
    categoryColor(generic) {
      const colorInfo = notificationColor[generic]
      return colorInfo
    },
    async updateOrg(url) {
      const payload = {
        orgCode: this.orgCode,
        name: this.orgData?.name,
        logo: url.doc_physical_path
      }
      try {
        const response = await this.$axios.put('/org/info', payload)

        if (response.data.success) {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.error('Error updating org.', error)
      }
    },
    // async fetchChecklist(id) {
    //   try {
    //     if (!id) return
    //     const response = await this.$axios.get(`/orgSetup/org-onboarding-checklist/${id}`)
    //     console.log(Object.values(response.data?.checklist))
    //     const isAnyChecklistInComplete = Object.values(response.data?.checklist).some(
    //       (item) => item.completed === false
    //     )
    //     console.log(isAnyChecklistInComplete)
    //     if (isAnyChecklistInComplete) {
    //       localStorage.setItem('needsInitialSetup', 'true')
    //     }
    //   } catch (error) {
    //     console.log(error)
    //   }
    // },
    async getOrgData() {
      try {
        const response = await this.$axios.get('/organizations')
        this.orgData = response.data?.organizations[0]
        if (this.orgData.plan_status && this.orgData.plan_details) {
          this.planStatus = this.orgData.plan_status === 'active' ? false : true
        }

        localStorage.setItem('orgData', JSON.stringify(this.orgData))
        localStorage.setItem('organization_code', this.orgData?.code)
        // await this.fetchChecklist(this.orgData?.id)
      } catch (error) {
        console.error('Error getting organization data.', error)
      }
    },
    openDialerCard() {
      this.isDialerOpen = !this.isDialerOpen
    },
    openComplaintCard() {
      this.isComplaintOpen = !this.isComplaintOpen
      if (this.isComplaintOpen) {
        this.isHelpTextVisible = false
        clearInterval(this.helpTextInterval)
      } else {
        this.startHelpTextLoop()
      }
    },
    startHelpTextLoop() {
      this.helpTextInterval = setInterval(() => {
        this.isHelpTextVisible = true
        setTimeout(() => {
          this.isHelpTextVisible = false
        }, 6000)
      }, 10000)
    },
    downloadApp() {
      const appLink = process.env.VUE_APP_EMP_APP_LINK
      window.open(appLink, '_blank')
    },
    isCallingAllowed(moduleName) {
      return isModuleFeatureAllowed('ADDONS', moduleName)
    },
    isbellIconEnabled(moduleName) {
      return (
        hasPermission(this.userData, permissionData.notificationRead) && isModuleVisible(moduleName)
      )
    },
    toggleOptionsDrawer() {
      this.isOptionsDrawerOpen = !this.isOptionsDrawerOpen
    },
    async fetchEmployees() {
      try {
        const chain = JSON.parse(localStorage.getItem('userReporteeChain'))
        if (chain) {
          return
        }

        const allUser = {
          limit: '*',
          sortBy: 'firstName',
          sortOrder: 'asc'
        }
        const response = await this.$axios.get(axiosUrl.employees.getEmployees, {
          params: allUser
        })
        if (response.data.success) {
          const userTree = this.constructReporteeTree(response.data.users)
          this.$storage.setUniversal('userReporteeChain', userTree)
          // Keep localStorage for backward compatibility if needed, though $storage usually handles it
          localStorage.setItem('userReporteeChain', JSON.stringify(userTree))
        }
      } catch (error) {
        console.error('Error fetching employees:', error)
      }
    },
    constructReporteeTree(data) {
      const map = {}
      data.forEach((employee) => {
        map[employee._id] = { ...employee }
      })

      const buildReportesToChain = (employee, visited = new Set()) => {
        if (!employee.reportesTo || !employee.reportesTo._id) return null

        const managerId = employee.reportesTo._id
        if (visited.has(managerId)) return null
        visited.add(managerId)

        const manager = map[managerId]

        if (!manager) return null

        return {
          firstName: manager.firstName,
          lastName: manager.lastName,
          fullName: manager.fullName,
          reportesTo: buildReportesToChain(manager, visited),
          _id: manager._id
        }
      }

      const buildManagerChain = (employee) => {
        const chain = []
        let current = employee
        const visited = new Set()

        while (current.reportesTo && current.reportesTo._id) {
          const managerId = current.reportesTo._id

          if (visited.has(managerId)) break
          visited.add(managerId)

          const manager = map[managerId]
          if (!manager) break
          chain.push(manager.fullName)
          current = manager
        }

        return chain.join(' -> ')
      }

      const tree = {}
      data.forEach((employee) => {
        tree[employee._id] = {
          firstName: employee.firstName,
          lastName: employee.lastName,
          fullName: employee.fullName,
          reportesTo: buildReportesToChain(employee),
          managerChain: buildManagerChain(employee),
          _id: employee._id
        }
      })
      return tree
    },
    async fetchAllUseCases() {
      try {
        const res = await this.$axios.get(`/orgSetup/extend-usecase`)
        this.allSubCases = res.data?.data
      } catch (error) {
        console.log(error)
      }
    },
    extractAllowedUseCaseName(key) {
      const allowedUseCase = this.allowedUseCases.find((u) => u.useCase === key)
      return { name: allowedUseCase?.navName, icon: allowedUseCase?.navIcon }
    },
    getUseCaseMenuItems() {
      if (!this.allowedUseCases || !this.allowedUseCases.length) return []

      return this.allowedUseCases
        .map((allowedUseCase) => {
          const useCase = allowedUseCase.useCase
          // Filter subcases that belong to this allowed use case
          const subCases = (this.allSubCases || []).filter((sc) => sc.useCase === useCase)

          if (subCases.length === 0) return null

          return {
            id: `usecase-${useCase}`,
            icon: allowedUseCase.navIcon || 'mdi-folder-multiple',
            // If navName is missing, use the name of the first subCase as the group title
            title: allowedUseCase.navName || convertToTitleCase(subCases[0].name),
            visible: true,
            childRoutes: subCases.map((subCase) => ({
              id: `usecase-${useCase}-${subCase._id}`,
              title: convertToTitleCase(subCase.name),
              icon: subCase?.icon || 'mdi-file-document',
              to: `/workforce/${useCase}/${subCase._id}`
            }))
          }
        })
        .filter((item) => item !== null)
    },
    showPopup(index, event) {
      const item = this.menuItems[index]
      if (this.hidePopupTimeout) {
        clearTimeout(this.hidePopupTimeout)
        this.hidePopupTimeout = null
      }
      if (this.currentHoveredItem === index && this.showItemPopup) {
        return
      }
      if (item && item.childRoutes && item.childRoutes.length > 0) {
        this.currentHoveredItem = index
        this.popupItems = item.childRoutes

        // Position the popup to the right of the hovered item
        const rect = event.currentTarget.getBoundingClientRect()
        this.popupPosition = {
          top: rect.top + window.scrollY,
          left: rect.right + 10
        }

        this.showItemPopup = true
      } else {
        this.scheduleHidePopup()
      }
    },

    scheduleHidePopup() {
      if (this.hidePopupTimeout) {
        clearTimeout(this.hidePopupTimeout)
      }
      this.hidePopupTimeout = setTimeout(() => {
        this.showItemPopup = false
        this.currentHoveredItem = null
        this.hidePopupTimeout = null
      }, 300)
    },

    cancelHidePopup() {
      if (this.hidePopupTimeout) {
        clearTimeout(this.hidePopupTimeout)
        this.hidePopupTimeout = null
      }
    },

    navigateTo(path) {
      try {
        if (this.$route.path !== path) {
          this.$router.push(path)
        }
      } catch (error) {
        if (error.name !== 'NavigationDuplicated') {
          console.error('Navigation error:', error)
        }
      }
      this.showItemPopup = false
      this.currentHoveredItem = null
    },
    async initializeLayout() {
      await this.startHelpTextLoop()
      const savedTheme = localStorage.getItem('theme')
      if (savedTheme) {
        this.isDarkMode = savedTheme === 'dark'
        this.applyTheme()
      } else {
        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
        this.isDarkMode = prefersDark
        this.applyTheme()
      }
      await this.getOrgData()
      this.loadExternalScripts()
      this.fetchNotifications()
      await this.fecthAllowedUseCases()
      // this.initFb()
      const _this = this
      setInterval(function () {
        const user = _this.$storage.getUniversal('user')
        if (user) {
          _this.user_name = user?.first_name
        }
        if (user?.role[0] === 'SUPER_ADMIN') {
          _this.title = 'Super Admin Panel'
        }
      }, 100)
      const userDataFromStorage = this.$storage.getUniversal('user')
      this.user = userDataFromStorage
      const scope = userDataFromStorage?.scope
      const dynamicNavLinks = await this.getDynamicNavLinks()
      // console.log(dynamicNavLinks)
      await this.fetchAllUseCases() // Make sure to fetch use cases before creating menu items

      this.menuItems = [
        {
          id: 'dashboard',
          icon: 'mdi-apps',
          title: 'Dashboard',
          to: '/workforce/dashboard',
          visible:
            hasPermission(this.userData, permissionData.userRead) && isModuleVisible('dashboard')
        },
        {
          id: 'user',
          icon: 'mdi-account-group',
          title: 'Organization',
          to: '/workforce/organization',
          visible:
            hasPermission(this.userData, permissionData.userRead) &&
            isModuleVisible('employee_management')
        },
        {
          id: 'organization',
          icon: 'mdi-clock-time-four',
          title: 'Attendance',
          to: '/workforce/team-review',
          visible:
            hasPermission(this.userData, permissionData.attendenceRead) &&
            isModuleVisible('attendance_management') &&
            this.isEveryTabsInModule
        },
        ...dynamicNavLinks,
        ...this.getUseCaseMenuItems(),
        {
          id: 'customers',
          icon: 'mdi-account-tie',
          title: 'Customers',
          to: '/workforce/product-customers',
          visible:
            hasPermission(this.userData, permissionData.customerRead) &&
            !isModuleVisible('collection_management') &&
            isModuleVisible('customers') &&
            this.orgCode === 'MITTAL'
        },
        {
          id: 'customers',
          icon: 'mdi-account-supervisor',
          title: 'Customers',
          to: '/workforce/customers',
          visible:
            hasPermission(this.userData, permissionData.customerRead) &&
            isModuleVisible('collection_management') &&
            isModuleVisible('customers')
        },
        {
          id: 'accounts',
          icon: 'mdi-finance',
          title: 'Accounts',
          to: '/workforce/accounts',
          visible: process.env.VUE_APP_ENV === 'uat'
        },
        {
          id: 'inventory-partners',
          icon: 'mdi-handshake',
          title: 'Lenders',
          to: '/workforce/partners',
          visible: isModuleVisible('loan_management')
        },
        {
          id: 'workflow-steps',
          icon: 'mdi-source-branch',
          title: 'Workflows',
          to: '/workforce/workflow-steps',
          visible: isModuleVisible('loan_management')
        },
        {
          id: 'campaigns',
          icon: 'mdi-bullhorn',
          title: 'Campaigns',
          to: '/workforce/campaigns',
          visible: this.isCallingAllowed('CALL_A_CUSTOMER')
        },
        // inventory_management
        {
          id: 'product-allotment',
          icon: 'mdi-clipboard-list-outline',
          title: 'Inventory',
          to: '/workforce/product-inventory',
          visible: isModuleVisible('inventory_management')
        },
        {
          id: 'inventory-management',
          icon: 'mdi-package-variant',
          title: 'Part Management',
          to: '/workforce/stock-management',
          visible: this.sparePartEnabled
        },
        {
          id: 'inventory-settings',
          icon: 'mdi-cog-box',
          title: 'Part Settings',
          to: '/workforce/inventory-settings',
          visible: this.sparePartEnabled
        },
        {
          id: 'amc-management',
          icon: 'mdi-shield-check',
          title: 'AMC',
          to: '/workforce/amc',
          visible: this.amcEnabled
        },
        {
          id: 'report-management',
          icon: 'mdi-file-chart',
          title: 'Reports',
          to: '/workforce/reports',
          visible: isModuleVisible('reports')
        },
        {
          id: 'report-management',
          icon: 'mdi-form-select',
          title: 'Dynamic Forms',
          to: '/workforce/dynamic-responses',
          visible: true
        },
        {
          id: 'notification',
          icon: 'mdi-bell-badge',
          title: 'Notifications',
          to: '/workforce/notifications',
          visible:
            hasPermission(this.userData, permissionData.notificationRead) &&
            isModuleVisible('notifications')
        },
        {
          id: 'approvals',
          icon: 'mdi-bell-badge',
          title: 'Approvals',
          to: '/workforce/approvals',
          visible: true
        },
        {
          id: 'org-settings',
          icon: 'mdi-cog-outline',
          title: 'Settings',
          to: '/workforce/settings',
          visible:
            hasPermission(this.userData, permissionData.settingRead) && isModuleVisible('settings')
        }
        // {
        //   id: 'corporate-expenses',
        //   icon: 'mdi-cash-multiple',
        //   title: 'Corporate Expenses',
        //   to: '/workforce/corporate-expenses',
        //   visible:
        //     scope.indexOf('ADMIN_ACCESS') > -1 &&
        //     userData.role.indexOf('ORG_ADMIN') > -1 &&
        //     isModuleVisible('CLAIMS')
        // }
      ]

      await this.setupMenuItems()
      await this.fetchEmployees()

      // Fetch payment history after orgData is available
      if (this.orgData?.id) {
        await this.fetchPaymentHistory()
      }
    },
    async fetchPaymentHistory() {
      try {
        const orgId = this.orgData?.id
        const res = await this.$axios.get(`/orgSetup/payment-history/${orgId}`)
        const payments = res.data?.data || res.data
        const history = Array.isArray(payments) ? payments : [payments]

        if (history.length > 0) {
          const lastPayment = history[0]

          if (lastPayment) {
            const created = new Date(lastPayment.createdAt)
            const expiry = new Date(created)

            if (lastPayment.paymentType === 'MONTHLY') {
              expiry.setDate(expiry.getDate() + 30)
            } else if (lastPayment.paymentType === 'YEARLY') {
              expiry.setDate(expiry.getDate() + 365)
            }

            const now = new Date()
            const diffTime = expiry - now
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
            this.daysLeft = diffDays
            this.lastPaymentAmount = lastPayment.amount
            // this.planName = lastPayment.planId
          }
        }
      } catch (error) {
        console.error('Error fetching payment history', error)
      }
    },
    async setUser() {
      try {
        const res = await this.$axios.get('/cualitywork/auth-user')
        this.$storage.setUniversal('user', { ...res.data })
        this.$store.dispatch('setWfmPermissions', res.data.wfmPermissions)

        window.location.reload()
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style>
header > div.v-toolbar__content {
  width: 100%;
  padding-left: 0px !important;
}

.user-menu > button {
  width: 100% !important;
}

.back {
  background-color: #f7fafb;
}

.selected-menu {
  background: #21427d;
}

.dark .selected-menu {
  background-color: #4a95da;
}

/* Child route selected - lighter than parent */
.child-selected {
  background: #5581d4;
}

.dark .child-selected {
  background-color: #5581d4;
}

.selected-menu .text-blue-950 {
  color: white;
}

.selected-menu .white {
  color: white;
}

.justify-start .ssr-carousel-track {
  justify-content: flex-start !important;
}

.scroll-bar::-webkit-scrollbar {
  display: none;
}

.custom-btn {
  border-radius: 0px;
}

.v-application--is-ltr .wfm-navbar .v-list-item__action:first-child,
.v-application--is-ltr .wfm-navbar .v-list-item__icon:first-child {
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-bottom: 8px;
  margin-top: 8px;
}

.wfm-navbar {
  max-width: 300px;
}

/* .wfm-navbar .v-icon {
    font-size: 20px !important;
  } */

.image-container {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* .edit-btn {
  position: absolute !important;
  top: -8px;
  right: 0px;
  z-index: 10;
  padding: 2px;
  background-color: #ffffff;
  border-radius: 50%;
  border: 1px solid #2a83ff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
} */
/* .logo-icon {
  position: absolute !important;
  top: 10px;
  right: 18px;
  z-index: 2;
} */

/* .edit-btn:hover {
  background: #21427d;
  color: #fff;
}

.edit-btn::before {
  display: flex;
  align-items: center;
  justify-content: center;
} */

.colorText {
  color: #21427d;
}

.no-animation.v-btn--icon.v-size--default {
  width: auto;
  height: auto;
}

.no-animation.theme--light.v-btn:hover::before {
  opacity: 0;
}
.no-animation.theme--light.v-btn:hover::after {
  opacity: 0;
}
.fixed-bottom-btn {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  font-size: 10px !important;
}
.scrollable-list {
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  overflow-x: hidden;
}

.arrow {
  width: 8px;
  height: 8px;
  position: absolute;
  z-index: -1;
}

.arrow::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  transform: rotate(-45deg);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.help-text-container {
  background-color: #f0f0f0;
  padding: 5px 10px;
  border-radius: 10px;
  cursor: pointer;
  max-width: 250px;
}

.help-text {
  font-size: 14px;
  color: #21427d;
  font-weight: bold;
  text-align: center;
}
.options-drawer {
  width: 250px;
  background-color: #f7f7f7;
}

.dialer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialer-container {
  background: transparent;
  max-width: 90%;
  width: auto;
}

.query-container {
  position: fixed;
  top: 60%;
  left: 60%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  width: 100%;
  display: flex;
  justify-content: center;
}

.help-desk-container {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 50;
  display: flex;
  align-items: center;
  background: white;
}

.help-desk-btn {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.notification {
  z-index: 10;
}
.query-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.query-container {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 90%;
  width: auto;
}
.v-dialog > .v-card > .v-card__text {
  padding: 0px !important;
}

.popup-container {
  position: absolute;
  z-index: 1000;
  background: white;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  max-height: 400px;
  transition: all 0.3s ease-in-out;
}

/* Added left side direction triangle */
.popup-container::before {
  content: '';
  position: absolute;
  top: 15px;
  left: -10px;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #949393;
  z-index: 1001;
}

.popup-header {
  padding: 10px 15px;
  border-bottom: 1px solid #eee;
  background-color: #f5f5f5;
  border-radius: 6px 6px 0 0;
}

.popup-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #21427d;
  text-align: start;
}

.popup-content {
  max-height: 300px;
  overflow-y: auto;
}

.popup-item {
  display: flex;
  align-items: center;
  padding: 8px 15px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.popup-item-selected {
  background-color: #21427d;
  color: white;
}

.popup-item-selected .v-icon {
  color: white !important;
}

.scrollable-popup::-webkit-scrollbar {
  width: 6px;
}

.scrollable-popup::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.scrollable-popup::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.scrollable-popup::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

.dark .popup-container {
  background: #424242;
  color: white;
}

.dark .popup-header {
  background-color: #555;
  border-bottom: 1px solid #666;
}

.dark .popup-title {
  color: white;
}

.dark .popup-item:hover {
  background-color: #555;
}

.dark .popup-item-selected {
  background-color: #4a95da;
  color: white;
}

.dark .popup-item-selected .v-icon {
  color: white !important;
}

/* Added styles for dark mode triangle */
.dark .popup-container::before {
  border-right-color: #424242;
}

.mini-variant-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
}

.v-dialog > .v-card > .v-card__title {
  padding: 0px !important;
}

.form-title {
  font-size: 1.25rem;
  font-weight: 600;
  padding: 0px !important;
  color: #21427d;
  margin: 0;
}

.logo-preview-container {
  width: 500px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.img-size {
  /* max-width: 40px; */
  height: auto;
}
.download-image {
  width: 120px;
  /* aspect-ratio: 16/10; */
  object-fit: contain;
  margin-right: 10px;
  mix-blend-mode: color-burn;
}
.top-bar {
  padding: 0px !important;
}
</style>
